<template lang="html">
  <div class="choose-sku" v-if="showType" @click="chooseSku">
    <wrapper>
      <div class="cell">
        <div class="cell-l">
          <span class="key pf-medium">
            {{ chosenKey }}
          </span>
          <span class="value" :class="[isChosen ? 'pf-medium' : '']">
            {{ chooseValue }}
          </span>
        </div>
        <i class="cell-r icon-show-more" />
      </div>
    </wrapper>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Wrapper from '../../wrapper'

export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    chooseSku: {
      type: Function,
      default: () => () => {}
    },
    sku: {
      type: Object,
      default: () => {}
    },
    showType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // showType: false
    }
  },
  components: {
    Wrapper
  },
  computed: {
    ...mapState(['selectedSku']),
    isChosen() {
      return this.selectedSku && this.selectedSku.skuId
    },
    chosenKey() {
      if (this.isChosen) {
        return `已选`
      } else {
        return '规格'
      }
      // const skuid = this.product.skuid
      // const related_skuList = this.product.related_skulist
      // const checkedSku = related_skuList.filter(ele => ele.r_skuId === skuid)
      // let txt = '已选择“'
      // if (checkedSku.length > 0) {
      //     if (related_skuList.length > 1) { //
      //         this.showType = true
      //     } else {
      //         this.showType = false
      //     }
      //     checkedSku[0].attrlist.forEach((ele, i, arr) => {
      //         txt += `${ele.optiontext}`
      //         if (i === arr.length - 1) {
      //             txt += '”'
      //         }
      //     })
      // }
      // return txt
    },
    chooseValue() {
      return this.isChosen ? this.selectedSku.skuName : '请选择服务规格'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.choose-sku {
  height: rem(94px);
  .cell {
    height: rem(94px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cell-l {
      width: 90%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .key {
        font-size: rem(26px);
        color: #121212;
        margin-right: rem(36px);
      }
      .value {
        font-size: rem(26px);
        color: #262626;
      }
    }
  }
}
</style>
